export const lead = {
    LEAD_TYPE_ID: {
        INTERESTED: 1
    },
    LEAD_CHANNEL_ID: {
        APP: 1,
        TRACK: 2
    },
    LEAD_TYPE: {
        INTEREST: "INTEREST"
    },
    LEAD_CHANNEL: {
        APP: "APP",
        TRACK: "TRACK"
    },

    TIMING_IN_SECONDS: {
        FOUR_HOURS: 14400,
        TWENTY_FOUR_HOURS: 172800
    }
}


